export default {
  BusinessPurchaseApply: {
    header: {
      code: 'Purchase Requisition Number',
      supplier: 'Requested Supplier',
      warehouseCode: 'Requested Receiving Warehouse',
      arrivalTime: 'Requested Arrival Time',
      startData: 'Start Date',
      endData: 'End Date',
      status: 'Status',
      spuCode: 'Product Code',
      skuCode: 'SKU',
      applicant: 'Applicant'
    },

    review: 'Review',
    antiAudit: 'Anti audit',
    closeApplication: 'Close Requisition',
    purchaseOrder: 'Convert to Purchase Order',
    export: 'Export',
    warning1: 'There are documents with incorrect status, unable to perform current operation.',
    msgError: 'Purchase order has been generated for the requisition, unable to perform current operation.',
    warning2: 'Do you want to close the selected purchase requisitions? Once closed, the requisition cannot generate purchase orders.',
    warning3: 'Whether',
    warning4: 'Selected Documents',
    applicationExport: 'Purchase Requisition Export',
    Reduction: 'Cost Reduction Statistics Table',
    status: 'Purchase Request Status',
    isFill: 'Purchase Information Complete',
    copyPurchaseOrder: 'Copy Purchase Order',
    cancelledPurchase: 'Discard Purchase Request',
    cancelReason: 'Discard Reason',
    tableIsFill: 'Is Necessary Information Filled',
    confirmMessage: 'Is Copy of Purchase Order Confirmed?',
    planQty: 'Predicted Purchase Quantity',
    cnPurchasePrice: 'RMB Purchase Price',
    price: 'Estimated eBay Selling Price',
    foreignPurchasePrice: 'Foreign currency purchase price',
    usdFreight: 'USD Shipping Cost',
    cnyFreight: 'RMB Shipping Cost',
    handlePrice: 'Handling Fee',
    cabinetVolume: 'Container Volume',
    seaInlandFreight: 'Ocean and Inland Shipping Costs',
    ebayPaypalPrice: 'eBay + PayPal Fees',

    table: {
      code: 'Purchase Requisition Number',
      warehouseCode: 'Requested Receiving Warehouse',
      arrivalTime: 'Requested Arrival Time',
      status: 'Status',
      auditDate: 'Review time',
      planQty: 'Requested Quantity',
      alreadyQty: 'Purchased Quantity',
      waitQty: 'Unpurchased Quantity',
      remark: 'Remark',
      auditName: 'Reviewer',
      dailySales: 'Daily Sales Volume'
    },

    dataForm: {
      title: 'Purchase Requisition Account Information',
      code: 'Purchase Requisition Number',
      automatic: 'Automatic Generated',
      warehouseCode: 'Requested Receiving Warehouse',
      arrivalTime: 'Requested Arrival Time',
      remark: 'Remark',
      information: 'Product Information',
      addingGoods: 'Add Product',
      picture: 'Product Image',
      supplierCode: 'Requested Supplier',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      skuName: 'SKU Name',
      planQty: 'Requested Quantity',
      warehouseCodeText: 'Please Select Receiving Warehouse',
      arrivalTimeText: 'Please Select Arrival Time',
      planQtyText: 'Enter Requested Quantity',
      dialogText: 'Select Supplier Product',
      new: 'New',
      purchase: 'Purchase Requisition Number',
      msgError: 'Please Select a Product',
      orderQuantity: 'Unpurchased Quantity',
      quantity: 'Order Quantity',
      lastPrice: 'Tax-Inclusive Order Price',
      taxRate: 'Tax Rate',
      tax: 'Tax-Inclusive Amount',
      commodityCode: 'Supplier Product Code',
      commoditySku: 'Supplier SKU Code',
      commodityRemark: 'Product Remarks',
    }
  }
};
